import { useState } from 'react';
import { useNavigate, Link } from 'react-router';
import { useForgotPassword } from '../hooks/usePassword';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Field,
  FieldLabel,
} from '@/components/ui/field';
import { Card, CardContent } from '@/components/ui/card';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const forgotMutation = useForgotPassword();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    forgotMutation.mutate(
      { email },
      {
        onSuccess: () => {
          setSubmitted(true);
        },
      }
    );
  };

  if (submitted) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-full max-w-md">
          <Card>
            <CardContent className="pt-6">
              <div className="space-y-4 text-center">
                <h2 className="text-2xl font-bold">Check your email</h2>
                <p className="text-gray-600">
                  We've sent a password reset link to {email} (if it exists)
                </p>
                <p className="text-sm text-gray-500">
                  The link will expire in 24 hours.
                </p>
                <Link to="/login" className="text-blue-600 hover:underline">
                  Back to login
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-full max-w-md">
        <Card>
          <CardContent className="pt-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="text-center mb-6">
                <h1 className="text-2xl font-bold">Forgot Password?</h1>
                <p className="text-gray-600 text-sm mt-2">
                  Enter your email to receive a password reset link
                </p>
              </div>

              {forgotMutation.error && (
                <div className="rounded-md bg-red-50 p-3 text-sm text-red-600">
                  {forgotMutation.error.message}
                </div>
              )}

              <Field>
                <FieldLabel htmlFor="email">Email</FieldLabel>
                <Input
                  id="email"
                  type="email"
                  placeholder="m@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={forgotMutation.isPending}
                />
              </Field>

              <Button
                type="submit"
                className="w-full"
                disabled={forgotMutation.isPending}
              >
                {forgotMutation.isPending ? 'Sending...' : 'Send Reset Link'}
              </Button>

              <div className="text-center text-sm">
                Remember your password?{' '}
                <Link to="/login" className="text-blue-600 hover:underline">
                  Login
                </Link>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};